import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { removeContact } from '../../../state/contact/contactSlice';

export function* deleteContactSaga(action) {
    const { contactId } = action.payload;
    try {
        const { domain, user } = yield select(selectUserCredentials);
        const response = yield call(cirrusClient.delete, `/v2/domains/${domain}/users/${user}/contacts/${contactId}`);
        if (response.data.code === 202) {
            yield put(removeContact(contactId));
            yield put(showSnackbar({
                message: 'Contact deleted successfully',
                severity: 'success'
            }));
        }
    } catch (error) {
        console.error('Error deleting contact:', error);
        yield put(showSnackbar({
            message: 'Failed to delete contact',
            severity: 'error'
        }));
    }
}